import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { InputControl } from '../../ui-kit/Input/InputControl.js';
import { validatorObj } from './getObjectValidator.js';
import { getValidation } from './getValidation.js';
export const PartnerCommentsField = JSX(({ field, input }) => {
    const { required, ...rest } = input;
    return (_jsx(InputControl, { ...getValidation(field('partnerComments'), validatorObj.partnerComments, required), placeholder: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0443\u044E\u0449\u0438\u0439 \u0432\u0430\u0441 \u0432\u043E\u043F\u0440\u043E\u0441", isTextarea: true, ...rest }));
});
//# sourceMappingURL=PartnerCommentsField.js.map